var React = require('react');

function TheHumans (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14.5 7a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0zM16 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0zM4.5 17A3.5 3.5 0 0 1 8 13.5h8a3.5 3.5 0 0 1 3.5 3.5v1a1.5 1.5 0 0 1-1.5 1.5H6A1.5 1.5 0 0 1 4.5 18v-1zM3 17a5 5 0 0 1 5-5h8a5 5 0 0 1 5 5v1a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-1z","fill":"#fff"}));
}

TheHumans.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = TheHumans;

TheHumans.default = TheHumans;
